module.exports = __webpack_public_path__ + "img/222.1f94cebc.png";